/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { RangeControl, ToggleControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { columns, hasNavigation, hasPagination, spaceBetween } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'slider-options',
						initialOpen: true,
						label: () => {
							return __( 'Slider' );
						},
						cb: () => {
							return <>
								<RangeControl
									label={ __( 'Columns' ) }
									value={ columns }
									onChange={ ( value ) => {
										setAttributes( { columns: value } );
									} }
									min={ 1 }
									max={ 3 }
									step={ 1 } />
								<RangeControl
									label={ __( 'Slider space' ) }
									value={ spaceBetween }
									onChange={ ( value ) => {
										setAttributes( { spaceBetween: value } );
									} }
									min={ 0 }
									max={ 100 }
									step={ 1 }
									help={ __( 'Space between each slide.' ) } />
								<ToggleControl
									label={ __( 'Enable Navigation', 'gutenify' ) }
									checked={ hasNavigation }
									help={
										hasNavigation
											? __( 'Showing slider navigation.', 'gutenify' )
											: __( 'Toggle to enable slider navigation.', 'gutenify' )
									}
									onChange={ () => setAttributes( { hasNavigation: ! hasNavigation } ) }
								/>
								<ToggleControl
									label={ __( 'Enable Pagination', 'gutenify' ) }
									checked={ hasPagination }
									help={
										hasPagination
											? __( 'Showing slider pagination.', 'gutenify' )
											: __( 'Toggle to enable slider pagination.', 'gutenify' )
									}
									onChange={ () => setAttributes( { hasPagination: ! hasPagination } ) }
								/>
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
